import Vue from 'vue'
import stylus from '../../stylus/app.styl'

let breakpoints = {
    xs: parseInt(stylus.breakpointXs),
    sm: parseInt(stylus.breakpointSm),
    md: parseInt(stylus.breakpointMd),
    lg: parseInt(stylus.breakpointLg),
    xl: parseInt(stylus.breakpointXl)
}

Vue.use({
    install() {
        Vue.prototype.$breakpoints = new Vue({
            data: () => ({
                breakpoints,
                windowSize: null
            }),
            methods: {
                isGreaterThan(breakpoint) {
                    return this.windowSize.width > this.breakpoints[breakpoint]
                },
                isGreaterThanOrEqualTo(breakpoint) {
                    return this.windowSize.width >= this.breakpoints[breakpoint]
                }
            }
        })
    }
})


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/breakpoints.js